import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) return <p>Loading...</p>; // Avoid premature redirect
    if (!isAuthenticated) {
        return <Navigate to="/authenticate" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;